import axios from "axios";
import { jwtDecode } from "jwt-decode";

const BASE_URL = process.env.REACT_APP_BASE_URL;

let isRefreshing = false;
let refreshSubscribers = [];

export const refreshAccessToken = async () => {
  if (isRefreshing) {
    return new Promise((resolve) => {
      refreshSubscribers.push(resolve);
    });
  }

  isRefreshing = true;

  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) throw new Error("No refresh token available.");

    const response = await axios.post(`${BASE_URL}/common/refresh-token`, {
      refreshToken,
    });

    const newAccessToken = response.data.accessToken;
    localStorage.setItem("accessToken", newAccessToken);

    // Notify all pending requests to use the new token
    refreshSubscribers.forEach((callback) => callback(newAccessToken));
    refreshSubscribers = [];

    sessionStorage.setItem("hasPopupBeenShown", "false");
    return newAccessToken;
  } catch (error) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    window.location.href = "/"; // Redirect to login
    return null;
  } finally {
    isRefreshing = false;
  }
};

export const checkTokenExpiryAndRefresh = async () => {
  const token = localStorage.getItem("accessToken");
  if (!token) return;

  const decodedToken = jwtDecode(token);
  const currentTime = Date.now() / 1000;
  const timeLeft = decodedToken.exp - currentTime;

  if (timeLeft < 5) {
    await refreshAccessToken();
  }
};

// Run token expiry check every 30 seconds
setInterval(checkTokenExpiryAndRefresh, 30000);
